// Copyright 2021 Prescryptive Health, Inc.

import { locationClearAction } from "../actions/location-clear.action";
import { LocationDispatch } from "./location.dispatch";

export const locationClearDispatch = (
  dispatch: LocationDispatch
): void => {
  dispatch(locationClearAction());
};